import { SvgIconProps } from './icon-props';

export function ChevronBoldRight({ height = 20, width = 21, fill = 'none', role }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 21 20"
			fill={fill}
			role={role}
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="icons/navigation&#38;actions/arrow/chevron_bold">
				<path
					id="Mask"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.5 20L15.5 10L5.5 0V2L13.5 10L5.5 18V20Z"
					fill="#030303"
				/>
			</g>
		</svg>
	);
}
